import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'

const getPrivateFoundations = (state: RootState) => state.privateFoundations.data
const getLoading = (state: RootState) => state.privateFoundations.loading
const getError = (state: RootState) => state.privateFoundations.error
const getPaging = (state: RootState) => state.privateFoundations.paging

const makePrivateFoundations = createSelector([getPrivateFoundations], (privateFoundations) => {
  return privateFoundations.map((pf) => {
    const {
      organizationName = '',
      organizationUrl = '',
      organizationDescription = '',
      contriPaidDsbrsChrtblAmt: disbursedCharitableAmount = 0,
      GrantOrContributionPdDurYrGrpAmt: contributedCharityAmount = 0,
      ...rest
    } = pf

    const formattedDisbursedCharityAmount = (disbursedCharitableAmount ?? 0).toLocaleString('en-US')
    const formattedContributedCharityAmount = (contributedCharityAmount ?? 0).toLocaleString('en-US')

    return {
      ...rest,
      organizationUrl,
      organizationName,
      organizationDescription,
      disbursedCharitableAmount,
      contributedCharityAmount,
      formattedDisbursedCharityAmount,
      formattedContributedCharityAmount,
    }
  })
})

const makeLimitedPFs = createSelector([makePrivateFoundations], (pf) => pf.slice(0,3))

const makePFCount = createSelector([getPrivateFoundations], (PF) => {
  return (PF ?? []).length
})

export const PrivateFoundationsSelectors = {
  getPrivateFoundations,
  getLoading,
  getError,
  getPaging,
  makePrivateFoundations,
  makePFCount,
  makeLimitedPFs
}
